// "Uppdaterad sedan du läste" — sparas i webbläsaren i v1 (beslut i
// instruktionsbibliotek-komponentspec.md §8). Vi sparar instruktionens datum
// vid läsningen, inte dagens datum, så att en ny version alltid märks.

const NYCKEL = 'kp-instruktioner-last';
const HANDELSE = 'kp-instruktioner-last';

export function lasStatus() {
  try {
    return JSON.parse(window.localStorage.getItem(NYCKEL) || '{}') || {};
  } catch {
    return {};
  }
}

export function markeraLast(post) {
  if (!post || !post.nyckel || !post.datum) return;
  try {
    const status = lasStatus();
    if (status[post.nyckel] === post.datum) return;
    status[post.nyckel] = post.datum;
    window.localStorage.setItem(NYCKEL, JSON.stringify(status));
    window.dispatchEvent(new Event(HANDELSE));
  } catch { /* privat läge eller blockerad lagring: märkningen uteblir bara */ }
}

/** Läst tidigare och ändrad efter det. Aldrig läst räknas inte (det vore brus). */
export function uppdateradSedanLast(post, status) {
  const last = status[post.nyckel];
  return Boolean(last && post.datum && last < post.datum);
}

export const LASSTATUS_HANDELSE = HANDELSE;
